import { useLocation } from 'react-router-dom';

type UseCustomer = {
  isTrialCustomer: boolean;
  isExistingCustomer: boolean;
  isAgencyCustomer: boolean;
  isLetterCustomer: boolean;
  validCustomerParam: string;
};

export const customerParams = {
  trial: 'trial',
  existing: 'e',
  agency: 'agency',
  letter: 'letter',
};

const useCustomer = (): UseCustomer => {
  const params = new URLSearchParams(useLocation().search);

  let isTrialCustomer = false;
  let isExistingCustomer = false;
  let isAgencyCustomer = false;
  let isLetterCustomer = false;
  let validCustomerParam = '';

  if (params.get(customerParams.trial) !== null) {
    // トライアル向け（既存・新規問わず）
    isTrialCustomer = true;
    validCustomerParam = customerParams.trial;
  } else if (params.get(customerParams.existing) !== null) {
    // 既存業者向け
    isExistingCustomer = true;
    validCustomerParam = customerParams.existing;
  } else if (params.get(customerParams.agency) !== null) {
    // 代理店経由業者向け
    isAgencyCustomer = true;
    validCustomerParam = customerParams.agency;
  } else if (params.get(customerParams.letter) !== null) {
    // DM向け
    isLetterCustomer = true;
    validCustomerParam = customerParams.letter;
  }

  return { isTrialCustomer, isExistingCustomer, isAgencyCustomer, isLetterCustomer, validCustomerParam };
};

export default useCustomer;
